import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IStoreSlice, TSiteVersion } from "@/redux/slices/store/types";

export const getSiteVersion = createAsyncThunk(
  "store/getSiteVersion",
  async () =>
    await axios({
      method: "GET",
      url: `/api/site-version`,
    }).then((res) => res.data?.site_version)
);

const pending = (state: IStoreSlice) => {
  state.site_version.loading = true;
};

const fulfilled = (
  state: IStoreSlice,
  {
    payload,
  }: {
    payload: {
      currency: TSiteVersion["currency"];
      id: TSiteVersion["id"];
    };
  }
) => {
  state.site_version = {
    ...payload,
    loading: false,
  };
};

export default {
  action: getSiteVersion,
  pending,
  fulfilled,
};
